var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "custom-select" }, [
    _c(
      "button",
      {
        ref: "button",
        staticClass: "custom-select__select-button primary-text primary-border",
        attrs: {
          if: _vm.buttonId,
          type: "button",
          "aria-haspopup": "listbox",
          "aria-expanded": _vm.open ? "true" : "",
          "aria-labelledby": _vm.labelledBy
        },
        on: {
          click: function($event) {
            return _vm.emitOpen()
          },
          keydown: function($event) {
            return _vm.handleKeydown($event)
          }
        }
      },
      [_vm._v("\n        " + _vm._s(_vm.text) + "  ˅\n    ")]
    ),
    _vm._v(" "),
    _vm.displayClear
      ? _c(
          "button",
          {
            staticClass: "clear-button primary-background mb-3",
            attrs: { type: "button", "aria-label": _vm.ariaLabel },
            on: {
              click: function($event) {
                return _vm.$emit("select", [""])
              }
            }
          },
          [
            _c("span", { staticClass: "clear-button__icon secondary-text" }, [
              _vm._v("×")
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }